import { forwardRef, memo, ReactNode } from 'react';
import classes from 'classnames';
import styles from './Card.module.scss';

type Props = {
  children: ReactNode;
  className?: string;
  dataTest?: string;
  hasTopBanner?: boolean;
};

const Card = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, className, dataTest = 'card', hasTopBanner } = props;
  return (
    <div
      ref={ref}
      data-test={dataTest}
      className={classes(
        styles.card,
        hasTopBanner && styles.hasTopBanner,
        className,
      )}
    >
      {children}
    </div>
  );
});

const CardMemo = memo(Card);

export default CardMemo;
